// extracted by mini-css-extract-plugin
export default {"root":"ReturnButton_root__Na4ue","returnButtonIcon":"ReturnButton_returnButtonIcon__bToJR","fullWidth":"ReturnButton_fullWidth__FWbSA","isMobile":"ReturnButton_isMobile__mqGzT"};